import styled, { createGlobalStyle } from 'styled-components';

import { Placement } from './types';
import { ArrowPlacementOptions } from './utils';

export const TooltipArrow = styled.div<{
  placement?: Placement;
}>`
  width: 0px;
  height: 0px;
  border-style: solid;
  transform: rotate(0deg);
  position: absolute;
  z-index: 1;
  ${({ placement }) => ArrowPlacementOptions[placement ?? 'top']};
`;

export const AnimatedContent = styled.div`
  animation: fadeIn 0.13s ease-in-out;

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    20% {
      opacity: 0.3;
    }
    80% {
      opacity: 0.6;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const TooltipStyles = createGlobalStyle<{ arrowColor?: string }>`
   
   .rc-tooltip {
    opacity: 1;
    background: transparent;
    z-index: 1000;
   }


  .rc-tooltip-placement-topLeft  {
    z-index:970 !important;
  }

  .rc-tooltip-placement-bottomLeft  {
    z-index:970 !important;
  }

  .rc-tooltip-placement-bottom  {
    z-index:970 !important;
  }


  .rc-tooltip-inner {
    background-color: ${({ theme }) => theme.palette.darkGrey};
    color: ${({ theme }) => theme.palette.white};
    padding: 8px;
    border-radius: 4px;
    font-size: 14px;
  }

  .rc-tooltip-arrow {
    position: absolute;
    border-style: solid;
    border-color: ${({ arrowColor }) => arrowColor}  transparent ${({
  arrowColor,
}) => arrowColor} 
      transparent;
     margin: 0 !important;
     
  }

`;

export const Container = styled.div<{
  arrowColor?: string;
  arrowLeft?: number;
}>`
  & .rc-tooltip-placement-top .rc-tooltip-arrow {
    left: 50% !important;
    bottom: -5px !important;

    transform: translateX(-50%) !important;
    border-width: 8px 8.5px 0 8.5px !important;
    border-color: transparent transparent white transparent !important;
  }

  & .rc-tooltip-placement-topLeft .rc-tooltip-arrow {
    bottom: 2px !important;
    left: 24px !important;
    z-index: auto !important;
    border-width: 8px 8.5px 0 8.5px !important;
    border-color: ${({ arrowColor }) => arrowColor} transparent transparent
      transparent !important;
  }

  & .rc-tooltip-placement-topRight .rc-tooltip-arrow {
    bottom: 2px !important;
    right: 6px !important;
    left: unset !important;
    border-width: 8px 8.5px 0 8.5px !important;
    border-color: ${({ arrowColor }) => arrowColor} transparent transparent
      transparent !important;
  }

  & .rc-tooltip-placement-rightTop .rc-tooltip-arrow {
    left: -5px !important;
    top: 20px !important;
    bottom: unset !important;
    transform: translateY(-50%) !important;
    border-width: 8.5px 11px 8.5px 0 !important;
    border-color: transparent ${({ arrowColor }) => arrowColor} transparent
      transparent !important;
  }

  & .rc-tooltip-placement-right .rc-tooltip-arrow {
    left: -5px !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    border-width: 8.5px 11px 8.5px 0 !important;
    border-color: transparent ${({ arrowColor }) => arrowColor} transparent
      transparent !important;
  }

  & .rc-tooltip-placement-rightBottom .rc-tooltip-arrow {
    left: -3px !important;
    bottom: 10px !important;
    top: unset !important;
    border-width: 8.5px 11px 8.5px 0 !important;
    border-color: transparent ${({ arrowColor }) => arrowColor} transparent
      transparent !important;
  }

  & .rc-tooltip-placement-bottomRight .rc-tooltip-arrow {
    right: 6px !important;
    left: unset !important;
    top: 2px !important;
    border-width: 0 8.5px 8px 8.5px !important;
    border-color: transparent transparent ${({ arrowColor }) => arrowColor}
      transparent !important;
  }

  & .rc-tooltip-placement-bottom .rc-tooltip-arrow {
    left: 50% !important;
    top: -5px !important;
    transform: translateX(-50%) !important;
    border-width: 0 8.5px 8px 8.5px !important;
    border-color: transparent transparent ${({ arrowColor }) => arrowColor}
      transparent !important;
  }

  & .rc-tooltip-placement-bottomLeft .rc-tooltip-arrow {
    left: ${({ arrowLeft }) => (arrowLeft ? arrowLeft : 25)}px !important;
    top: 2px !important;
    border-width: 0 8.5px 8px 8.5px !important;
    border-color: transparent transparent ${({ arrowColor }) => arrowColor}
      transparent !important;
  }

  & .rc-tooltip-placement-leftBottom .rc-tooltip-arrow {
    right: -5px !important;
    bottom: 10px !important;
    top: unset !important;
    border-width: 8.5px 0 8.5px 12px !important;
    border-color: transparent transparent transparent
      ${({ arrowColor }) => arrowColor} !important;
  }

  & .rc-tooltip-placement-left .rc-tooltip-arrow {
    right: -5px !important;
    top: 50% !important;
    bottom: unset !important;

    transform: translateY(-50%) !important;
    border-width: 8.5px 0 8.5px 12px !important;
    border-color: transparent transparent transparent
      ${({ arrowColor }) => arrowColor} !important;
  }

  & .rc-tooltip-placement-leftTop .rc-tooltip-arrow {
    right: -5px !important;

    z-index: auto !important;
    top: 15px !important;
    transform: translateY(-50%) !important;
    border-width: 8.5px 0 8.5px 12px !important;
    border-color: transparent transparent transparent
      ${({ arrowColor }) => arrowColor} !important;
  }
`;
